'use strict';

var _ = require('lodash');
function FlightManagementDataRetrieverHelperService(momentService, configurationService, $filter) {
  var BOOKING_INTAKE_PERFORMANCE_TOTAL = 'bookingIntakePerformanceTotal';
  var BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS = 'bookingIntakePerformanceGroupBookings';
  var BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR = 'bookingIntakePerformanceLoadFactor';
  var BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN = 'bookingIntakePerformanceLowestClassOpen';
  var BOOKING_INTAKE_PERFORMANCE_TOTAL_LY = 'bookingIntakePerfTotalBookingsLY';
  var BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS_LY = 'bookingIntakePerfGroupBookingsLY';
  var BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR_LY = 'bookingIntakePerfLoadFactorLY';
  var BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN_LY = 'bookingIntakePerfLowestClassOpenLY';
  var INV_CONTROL_FIELD_NAME = 'inventoryControlField';
  var LOAD_FACTOR_FIELD_NAME = 'loadFactorField';
  var MAPPED_DEMAND_FIELD_NAME = 'mappedDemandProductGroup';
  var REGULAR_DEMAND_FIELD_NAME = 'regularDemandProductGroup';
  var SOURCE_PREFIX = 'source';
  var inventoryControlsMetricMap = {
    Availability: 'availEffective',
    Authorization: 'authEffective',
    Bookings: 'bookingEffective'
  };
  var rmMomentFormat = $filter('rmMomentFormat');
  function applyLowestClassOpenIndicator(lowestClassOpenIndex, inventoryControls, newEntry) {
    if (lowestClassOpenIndex === undefined || lowestClassOpenIndex < 0) {
      return;
    }
    var inventoryControl = inventoryControls[lowestClassOpenIndex];
    var fieldName = INV_CONTROL_FIELD_NAME + inventoryControl.className;
    if (newEntry.customClasses[fieldName]) {
      newEntry.customClasses[fieldName] += ' rm-jqx-grid-cell-red-border';
    } else {
      newEntry.customClasses[fieldName] = 'red-border';
    }
  }
  function getBackgroundClass(value) {
    return value > 0 ? 'green-background' : 'red-background';
  }
  function sortInventoryControlsByClassIndex(columns) {
    var classesIndexes = configurationService.getAllClassesIndexMapping();
    return columns.sort(function (a, b) {
      var value1 = classesIndexes[a.className];
      var value2 = classesIndexes[b.className];
      return value1 - value2;
    });
  }
  function getMomentOfDate(date, field, stringFormat) {
    return momentService.of(date, field, stringFormat);
  }
  function getMomentOfTime(date, field, memorizedMomentOfDate) {
    return memorizedMomentOfDate(date, field, 'HHmm');
  }
  function getYearMonthDayOfMoment(moment) {
    return rmMomentFormat(moment, 'DATE');
  }
  function getTrendClass(currValue, lyValue, customTrendUp, customTrendDown) {
    if (!currValue && !lyValue || currValue === lyValue || _.isNil(currValue) || _.isNil(lyValue)) {
      return '';
    }
    if (currValue > lyValue) {
      return customTrendUp || 'trend-up-double';
    }
    return customTrendDown || 'trend-down-double';
  }
  function generatePerformanceBookingIntakeOffsets(newEntry, bookingsIntakeData) {
    _.chain(bookingsIntakeData).groupBy('offset').each(function (offsetGroup, offset) {
      newEntry[BOOKING_INTAKE_PERFORMANCE_TOTAL + offset] = offsetGroup[0].intake;
      newEntry[BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS + offset] = offsetGroup[0].grouping;
      newEntry[BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR + offset] = offsetGroup[0].loadFactor;
      newEntry[BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN + offset] = offsetGroup[0].lowestClassOpen;
      newEntry[BOOKING_INTAKE_PERFORMANCE_TOTAL_LY + offset] = offsetGroup[0].intakeLY;
      newEntry[BOOKING_INTAKE_PERFORMANCE_GROUP_BOOKINGS_LY + offset] = offsetGroup[0].groupingLY;
      newEntry[BOOKING_INTAKE_PERFORMANCE_LOAD_FACTOR_LY + offset] = offsetGroup[0].loadFactorLY;
      newEntry[BOOKING_INTAKE_PERFORMANCE_LOWEST_CLASS_OPEN_LY + offset] = offsetGroup[0].lowestClassOpenLY;
    }).value();
  }
  function generateInventoryControls(inventoryControls, distinctClassNames, newEntry, metricFieldNames, controlType) {
    var lowestClassOpenIndex;
    var unionInventoryControls = _.unionBy(inventoryControls, distinctClassNames, 'className');
    metricFieldNames = metricFieldNames || inventoryControlsMetricMap;
    inventoryControls = sortInventoryControlsByClassIndex(unionInventoryControls);
    _.forEach(unionInventoryControls, function (inventoryControl, index) {
      var fieldName = INV_CONTROL_FIELD_NAME + inventoryControl.className;
      if (Object.keys(inventoryControl).length === 1) {
        newEntry[fieldName] = null;
        newEntry.customClasses[fieldName] = null;
        return;
      }
      if (inventoryControl.availModel > 0) {
        lowestClassOpenIndex = index;
      }
      newEntry[fieldName] = inventoryControl[metricFieldNames[controlType ? controlType : 'Availability']];
      newEntry[SOURCE_PREFIX + fieldName + metricFieldNames.Availability] = inventoryControl[metricFieldNames.Availability];
      newEntry[SOURCE_PREFIX + fieldName + metricFieldNames.Authorization] = inventoryControl[metricFieldNames.Authorization];
      newEntry[SOURCE_PREFIX + fieldName + metricFieldNames.Bookings] = inventoryControl[metricFieldNames.Bookings];
      newEntry.customClasses[fieldName] = getBackgroundClass(inventoryControl[metricFieldNames.Availability]);
    });
    applyLowestClassOpenIndicator(lowestClassOpenIndex, inventoryControls, newEntry);
  }
  function generateLoadFactors(legLoadFactorDetails, newEntry) {
    _.forEach(legLoadFactorDetails, function (loadFactorDetail, index) {
      var legIndex = index + 1;
      var fieldName = LOAD_FACTOR_FIELD_NAME + 'Leg' + legIndex;
      newEntry[fieldName] = loadFactorDetail.loadFactor;
      newEntry['lastYear' + fieldName] = loadFactorDetail.lastYearLoadFactor;
      newEntry.customClasses[fieldName] = getTrendClass(loadFactorDetail.loadFactor, loadFactorDetail.lastYearLoadFactor);
    });
  }
  function generateDemandColumns(inventoryControls, newEntry) {
    _.forEach(inventoryControls, function (inventoryControl) {
      var fieldName = MAPPED_DEMAND_FIELD_NAME + inventoryControl.classGroup;
      if (inventoryControl.flowType === 'REGULAR') {
        fieldName = REGULAR_DEMAND_FIELD_NAME + inventoryControl.classGroup;
      }
      if (newEntry[fieldName]) {
        newEntry[fieldName] += inventoryControl.remainingDemandFC;
      } else {
        newEntry[fieldName] = inventoryControl.remainingDemandFC;
      }
    });
  }
  function applyControlType(rows, controlType) {
    var newSourceAttribute = inventoryControlsMetricMap[controlType];
    _.forEach(rows, function (row) {
      _.forOwn(row, function (value, key) {
        if (_.startsWith(key, INV_CONTROL_FIELD_NAME)) {
          row[key] = row[SOURCE_PREFIX + key + newSourceAttribute];
        }
      });
    });
    return rows;
  }
  return {
    getMomentOfDate: getMomentOfDate,
    getMomentOfTime: getMomentOfTime,
    getTrendClass: getTrendClass,
    generateInventoryControls: generateInventoryControls,
    generateLoadFactors: generateLoadFactors,
    generateDemandColumns: generateDemandColumns,
    applyControlType: applyControlType,
    getYearMonthDayOfMoment: getYearMonthDayOfMoment,
    generatePerformanceBookingIntakeOffsets: generatePerformanceBookingIntakeOffsets
  };
}
FlightManagementDataRetrieverHelperService.$inject = ['MomentService', 'ConfigurationService', '$filter'];
module.exports = FlightManagementDataRetrieverHelperService;